import { FC } from "react";

interface PaybackProps {
    graficoConsumo: string,
    consumo_total: number,
    geracao_total: number,
}

const PaybackConsumo: FC<PaybackProps> = ({
    graficoConsumo,
    consumo_total,
    geracao_total,
}) => {
    return <>
        <div className="sub-title-minor">Geração mensal estimada* </div>

        <div className="subTitleGrafico"><strong>Gráfico de consumo</strong></div>
        <img src={`data:tipo_da_imagem/extensao;base64,${graficoConsumo}`} className="grafConsumoPayback" alt="Imagem grafico consumo"></img>

        <div className="container-prazo-entrega">
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >*</div>
                <div className="texto-prazo-entrega"><span>A taxa mínima da concessionária não é contemplada como consumo.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega"><span>Geração Solar Total: de acordo com as informações adicionadas no projeto a geração anual estimada* será de aproximadamente {Number(Number(geracao_total).toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) || 0} kWh/ano.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega"><span>Consumo Total: de acordo com as informações adicionadas no projeto o consumo atual durante o período de um ano é de {Number(Number(consumo_total).toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) || 0} kWh/ano</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega"><span>A geração é calculada considerando que os painéis solares serão instalados com inclinação ideal, voltados para a direção norte, sem sombreamento e com a manutenção adequada (Limpeza, etc), conforme Manual do Produto.</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega"><span>Esses valores são de referência e podem variar considerando as condições climáticas do local (conforme indicado no manual do módulo).</span></div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega"><span>Valores de HSP (Horas de Sol Pico) com base no banco de dados do INPE (2006).</span></div>
            </div>
        </div>

        <div style={{marginTop: "15pt"}}></div>
    </>
}

export default PaybackConsumo;